import { styled } from "styled-components";

import { getReferenceColor } from "../styled";

export const CheckboxContainer = styled.div`
  margin-right: 5px;
  cursor: pointer;
`;

export const SummaryContainer = styled.div`
  border: 1px solid var(--palette-border-neutral-subtle);
  border-bottom: none;
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 104px;
  border-radius: 4px 4px 0px 0px;
  overflow: auto;
`;

export const SummaryItemWrapper = styled.div`
  flex: 1;
  width: 100%;
  flex-direction: column;
  display: flex;
  align-items: flex-start;
  @media (max-width: 768px) {
    flex: 1 1 0%;
    width: 100%;
    flex-direction: row;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
  }
`;

export const MetricSummaryItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MetricData = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MetricReferenceValueText = styled.span<{ success: boolean }>`
  display: flex;
  flex-direction: row;
  font-size: 12px;
  color: ${getReferenceColor};
  margin: 0;
`;

export const MetricReferenceBasicValueText = styled.span`
  font-size: 12px;
  color: var(--palette-content-neutral-strong);
`;

export const MetricReferenceText = styled.div`
  margin-left: 5px;
  color: var(--palette-content-neutral-strong);
`;

export const SummaryItemTextStyled = styled.div<{ extraTitleHeight: boolean }>`
  font-size: 14px;
  color: var(--palette-content-neutral-strong);
  font-weight: 400;
  height: ${(props) => (props.extraTitleHeight ? 4 : 3)}em;
  margin: 0 0 10px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 640px) {
    color: var(--palette-content-neutral-strong);
    font-weight: 600;
  }

  @media (max-width: 1536px) {
    height: 4em;
  }
`;

export const SummaryItemContainer = styled.div`
  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  min-width: 140px;
  border-radius: 0px;
  background-color: var(--palette-bg-neutral-base);
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  width: 100%;
`;

export const Space = styled.div`
  align-items: center;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const SummaryValueRow = styled.div`
  display: flex;
  flex-direction: row;
`;
